module.exports = __webpack_public_path__ + "img/d5d8d33.png";